import apiClient from "./client";
import { unwrapApiResponse } from "../utils/apiError";

export const studentAPI = {
  getTeacherStudents: async (params = {}) => {
    const response = await apiClient.get("/teacher/students", { params });
    return unwrapApiResponse(response);
  },

  updateStudentLevel: async ({
    classSubjectId,
    studentId,
    date,
    level,
    description = "",
  }) => {
    const response = await apiClient.patch(
      `/teacher/class-subjects/${classSubjectId}/students/${studentId}/level`,
      { date, level: level == null ? level : String(level), description }
    );
    return unwrapApiResponse(response);
  },

  updateStudentDiscipline: async ({
    classSubjectId,
    studentId,
    date,
    discipline,
    description = "",
  }) => {
    const response = await apiClient.patch(
      `/teacher/class-subjects/${classSubjectId}/students/${studentId}/discipline`,
      {
        date,
        discipline: discipline == null ? discipline : String(discipline),
        description,
      }
    );
    return unwrapApiResponse(response);
  },
};
